import axios from "axios";
import qs from "qs";
import { API_CLIENT_DOMAIN } from "../constants";
import { handleError } from "../errorHandler";

export const getApplications = (
  skip: number,
  limit: number,
  orderingProperty: string,
  orderingDirection: string,
  name: string,
  packageName: string,
  platformList: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    skip: skip,
    limit: limit,
    "ordering[0][property]":
      orderingProperty.length > 0 ? orderingProperty : null,
    "ordering[0][direction]":
      orderingDirection.length > 0 ? orderingDirection : null,
    name: name.length > 0 ? name : null,
    packageName: packageName.length > 0 ? packageName : null,
    platformList: platformList.length > 0 ? platformList : null,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/application", {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: false, skipNulls: true }),
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const getApplication = (
  id: number,
  onSuccess: Function,
  onFailure: Function
) => {
  axios
    .get(API_CLIENT_DOMAIN + "/application/" + id)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const createApplication = (
  name: string,
  packageName: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const data = {
    name: name,
    packageName: packageName,
  };

  axios
    .post(API_CLIENT_DOMAIN + "/application", data)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const getApplicationsCount = (
  name: string,
  packageName: string,
  platformList: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    name: name.length > 0 ? name : null,
    packageName: packageName.length > 0 ? packageName : null,
    platformList: platformList.length > 0 ? platformList : null,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/application/count", {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: false, skipNulls: true }),
    })
    .then((response) => {
      onSuccess(response.data.count);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const modifyApplication = (
  id: number,
  name: string,
  version: number,
  onSuccess: Function,
  onFailure: Function
) => {
  const data = {
    name: name,
    version: version,
  };

  axios
    .patch(API_CLIENT_DOMAIN + "/application/" + id, data)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const getApplicationVersions = (
  id: number,
  skip: number,
  limit: number,
  orderingProperty: string,
  orderingDirection: string,
  name: string,
  processorList: string,
  platformList: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    skip: skip,
    limit: limit,
    "ordering[0][property]":
      orderingProperty.length > 0 ? orderingProperty : null,
    "ordering[0][direction]":
      orderingDirection.length > 0 ? orderingDirection : null,
    name: name.length > 0 ? name : null,
    processorList: processorList.length > 0 ? processorList : null,
    platformList: platformList.length > 0 ? platformList : null,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/application/" + id + "/version", {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: false, skipNulls: true }),
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const createApplicationVersion = (
  id: number,
  name: string,
  platform: string,
  notifications: object,
  file: File,
  onSuccess: Function,
  onFailure: Function
) => {
  let formData = new FormData();
  formData.append("name", name);
  formData.append("platform", platform);
  formData.append("notifications", JSON.stringify(notifications));
  formData.append("file", file);

  axios
    .post(API_CLIENT_DOMAIN + "/application/" + id + "/version", formData, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const getApplicationVersionsCount = (
  id: number,
  name: string,
  processorList: string,
  platformList: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    name: name.length > 0 ? name : null,
    processorList: processorList.length > 0 ? processorList : null,
    platformList: platformList.length > 0 ? platformList : null,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/application/" + id + "/version/count", {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: false, skipNulls: true }),
    })
    .then((response) => {
      onSuccess(response.data.count);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const isApplicationUnique = (
  packageName: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    packageName: packageName,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/application/unique", {
      params,
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};

export const isApplicationVersionUnique = (
  id: number,
  name: string,
  platform: string,
  onSuccess: Function,
  onFailure: Function
) => {
  const params = {
    name: name,
    platform: platform,
  };

  axios
    .get(API_CLIENT_DOMAIN + "/application/" + id + "/version/unique", {
      params,
    })
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};
